/**
 * Instruments d'analyse — galerie des capacités spécialisées.
 * Sorties du menu principal (A2, nav 6 univers) mais toujours accessibles ici,
 * via la barre NOAM et via l'univers « Instruments » du monde agentique.
 * SOURCE UNIQUE : src/lib/universes.js (getInstruments) — zéro liste divergente.
 */
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Sparkles, ChevronRight } from "lucide-react";
import { getInstruments } from "@/lib/universes";

export default function Instruments() {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const en = (i18n.language || "fr").startsWith("en");
  return (
    <div className="space-y-5" data-testid="instruments-page">
      <div>
        <h1 className="text-lg font-semibold text-zinc-100 flex items-center gap-2">
          <Sparkles className="w-5 h-5 text-[#43C6D8]" />
          {t("saas.nav.instruments", { defaultValue: "Instruments d'analyse" })}
        </h1>
        <p className="text-zinc-400 text-xs max-w-3xl mt-1">
          {t("saas.instruments.intro", { defaultValue: "Les capacités spécialisées de Noam. Astuce : demandez-les directement à Noam dans la barre d'intention, il ouvrira le bon instrument." })}
        </p>
      </div>
      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-3">
        {getInstruments().map((it) => (
          <button key={it.to} onClick={() => navigate(it.to)}
            className="text-left bg-zinc-900/60 border border-zinc-800 hover:border-[#43C6D8]/50 rounded-lg p-4 transition-colors group"
            data-testid={`instrument-${it.to.replace(/\//g, "-").replace(/^-+/, "")}`}>
            <div className="flex items-center justify-between">
              <div className="text-sm font-medium text-zinc-100 flex items-center gap-2">
                <it.icon className="w-4 h-4 text-[#43C6D8]" /> {it.label}
              </div>
              <ChevronRight className="w-4 h-4 text-zinc-600 group-hover:text-[#43C6D8]" />
            </div>
            <div className="text-[11px] text-zinc-500 mt-1">{en ? it.desc.en : it.desc.fr}</div>
          </button>
        ))}
      </div>
    </div>
  );
}
